function Haiti({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1325)">
        <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 7.1635 16 0 16 0C16 0 32 7.1635 32 16Z" fill="#A2001D"/>
        <path d="M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16" fill="#0052B4"/>
        <path d="M21.5652 20.1739L16 19.4782L10.4348 20.1739V11.826H21.5652V20.1739Z" fill="#F0F0F0"/>
        <path d="M16 19.4782C17.5368 19.4782 18.7827 18.2324 18.7827 16.6956C18.7827 15.1588 17.5368 13.913 16 13.913C14.4632 13.913 13.2174 15.1588 13.2174 16.6956C13.2174 18.2324 14.4632 19.4782 16 19.4782Z" fill="#0052B4"/>
        <path d="M16 18.0869C16.7684 18.0869 17.3913 17.464 17.3913 16.6956C17.3913 15.9272 16.7684 15.3043 16 15.3043C15.2316 15.3043 14.6086 15.9272 14.6086 16.6956C14.6086 17.464 15.2316 18.0869 16 18.0869Z" fill="#A2001D"/>
        <path d="M13.9131 13.2174H18.087L16 15.3044L13.9131 13.2174Z" fill="#6DA544"/>
        <path d="M15.3043 14.6086H16.6956V18.7826H15.3043V14.6086Z" fill="#FFDA44"/>
        <path d="M18.2261 18.3652H13.7738L10.4348 20.174H21.5652L18.2261 18.3652Z" fill="#6DA544"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Haiti;
